jQuery(document).ready(function ($) {
  
    var price = 70;

    function updateSharesFields() {
      var shares = Number( $(".webform-submission-mitglied-werden-form .js-form-item-anteile input[name='anteile']").val() );
      if (shares > 999) {
        shares = 999;
        $(".webform-submission-mitglied-werden-form .js-form-item-anteile input[name='anteile']").val(shares);
      }
      $(".webform-submission-mitglied-werden-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']").val(shares + 1).addClass('active');
      var shares_total = Number( $(".webform-submission-mitglied-werden-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']").val() );
      $(".webform-submission-mitglied-werden-form .js-form-item-euro input[name='euro']").val(shares_total * price).addClass('active');
    }

    $(document).on('change', ".webform-submission-mitglied-werden-form input[name='erklaere_beitritt_mit_1_anteil']", function() {
      updateSharesFields();
    });

    $(document).on('blur keyup keydown change', ".webform-submission-mitglied-werden-form .js-form-item-anteile input[name='anteile']", function() {
      updateSharesFields();
    });

    $(document).on('keydown', ".webform-submission-mitglied-werden-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']", function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode != 9) {
        return false;
      }
    });

    $(document).on('keydown', ".webform-submission-mitglied-werden-form .js-form-item-euro input[name='euro']", function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode != 9) {
        return false;
      }
    });



    function totalSharesUpdate() {
      var shares_existing = Number( $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-bisherige-anteile input[name='bisherige_anteile']").val() );
      var shares_new = Number( $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile input[name='anteile']").val() );
      if (shares_new + shares_existing > 1000) {
        shares_new = 1000 - shares_existing;
        $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile input[name='anteile']").val(shares_new);
      }
      $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']").val(shares_existing + shares_new).addClass('active');
    }

    $(document).on('blur keyup keydown change', ".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile input[name='anteile']", function() {
      if (this.value) {
        $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-euro input[name='euro']").val(this.value * price).addClass('active');
        totalSharesUpdate();
      }
    });

    $(document).on('blur', ".webform-submission-weitere-anteile-zeichnen-form .js-form-item-euro input[name='euro']", function() {
      var shares = Math.floor(this.value / price);
      $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile input[name='anteile']").val(shares).addClass('active');
      $(".webform-submission-weitere-anteile-zeichnen-form .js-form-item-euro input[name='euro']").val(shares * price).addClass('active');
      totalSharesUpdate();
    });

    $(document).on('blur keyup keydown change', ".webform-submission-weitere-anteile-zeichnen-form .js-form-item-bisherige-anteile input[name='bisherige_anteile']", function() {
      totalSharesUpdate();
    });

    $(document).on('keydown', ".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']", function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode != 9) {
        return false;
      }
    });

    $(document).on('blur', ".webform-submission-weitere-anteile-zeichnen-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']", function() {
      totalSharesUpdate();
    });


    $(document).on('click', ".webform-submission-mitglied-werden-form .js-form-item-markup-04 a.clear-fields, .webform-submission-weitere-anteile-zeichnen-form .js-form-item-markup-04 a.clear-fields", function() {
      $("input[name='vorname2']").val('').removeClass('active');
      $("input[name='nachname2']").val('').removeClass('active');
      $("input[name='strasse_und_nr_2']").val('').removeClass('active');
      $("input[name='postleitzahl2']").val('').removeClass('active');
      $("input[name='ort2']").val('').removeClass('active');
    });
    $(document).on('click', ".webform-submission-mitglied-werden-form .js-form-item-markup-04 a.copy-fields, .webform-submission-weitere-anteile-zeichnen-form .js-form-item-markup-04 a.copy-fields", function() {
      var vorname = $("input[name='vorname']").val();
      $("input[name='vorname2']").val(vorname).addClass('active');
      var nachname = $("input[name='nachname']").val();
      $("input[name='nachname2']").val(nachname).addClass('active');
      var strasse_und_nr = $("input[name='strasse_und_nr_']").val();
      $("input[name='strasse_und_nr_2']").val(strasse_und_nr).addClass('active');
      var postleitzahl = $("input[name='postleitzahl']").val();
      $("input[name='postleitzahl2']").val(postleitzahl).addClass('active');
      var ort = $("input[name='ort']").val();
      $("input[name='ort2']").val(ort).addClass('active');
    });


    $(".webform-submission-mitglied-werden-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']").attr('readonly', true);
    $(".webform-submission-mitglied-werden-form .js-form-item-euro input[name='euro']").attr('readonly', true);

    $(document).on('keyup keydown change', ".webform-submission-mitglied-werden-form .js-form-item-anteile-gesamt input[name='anteile_gesamt']", function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).attr('readonly', true);
    });

});
